import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import styled from 'styled-components';
import { BsThreeDots } from 'react-icons/bs';
import { PropTypes } from 'prop-types';

export const MoreOptions = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
  z-index: 1000;

  &:hover {
    background: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.3);
  }

  svg {
    color: #333;
    font-size: 16px;
  }
`;

const DropdownMenu = styled.div`
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  overflow: hidden;
`;

const MenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 8px 16px;
  background: transparent;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;

  &:hover {
    background: #be1622;
    color: #ffffff;
  }
`;

const MoreOptionsComponent = ({ options }) => (
  <Popup
    trigger={
      <MoreOptions>
        <BsThreeDots size={15} />
      </MoreOptions>
    }
    position="left top"
    on="hover"
    closeOnDocumentClick
    mouseLeaveDelay={300}
    mouseEnterDelay={0}
    contentStyle={{ padding: '0px', border: 'none' }}
    arrow={false}
  >
    <DropdownMenu>
      {options.map(({ label, onClick }) => (
        <MenuItem key={label} onClick={onClick} type="button">
          {label}
        </MenuItem>
      ))}
    </DropdownMenu>
  </Popup>
);

MoreOptionsComponent.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
};

export default MoreOptionsComponent;
